import React, { useEffect, useState, useCallback } from "react";
import { apiUrlGestor, SaveSpotGuarda, urlRoot, eventRoot,apiODD } from "../global";
import "react-datepicker/dist/react-datepicker.css";
import "./forms.css";
import "./General.css";
import * as moment from "moment";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import sleep from "sleep-promise";
//import IntlTelInput from 'react-intl-tel-input';
//import 'react-intl-tel-input/dist/main.css';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function Form({
  Evento,
  ClCampus,
  NivelEvento,
  EventoRegistrado,
  emailInput,
  viweForm,
  AvisoInput,
  InfoCampus
}) {
  const [campus, setCampus] = useState(null);
  const [mustraSelects, setmustraSelects] = useState(false);
  const [mustraArea, setmustraArea] = useState(false);
  const [mustraPrograma, setmusPrograma] = useState(false);
  const [periodos, setPeriodos] = useState(null);
  const [generos, setGeneros] = useState(null);
  const [horarios, setHorarios] = useState(null);
  const [areaInteres, setAreaInteres] = useState(null);
  const [programaInteres, setProgramasInteres] = useState(null);
  const [isEnglish, setisEnglish] = useState(0); // ESTE VARIABLE SE REFIERE AL IDIOMA
  const [nombre, setNombre] = useState("");
  const [apellidoPaterno, setApellidoPaterno] = useState("");
  const [apellidoMaterno, setApellidoMaterno] = useState("");
  const [telefono, setTelefono] = useState("");
  const [fecha, setFecha] = useState("");
  const [EscuelaProveedoraS, setEscuelaProveedoraS] = useState("");
  const [sexoLegal, setsSxoLegal] = useState("");
  const [horario, setHorario] = useState("");
  const [email, setEmail] = useState("");
  // valores seleccionados de cada campo
  const [campusS, setCampusS] = useState("");
  const [periodosS, setPeriodosS] = useState("");
  const [areaInteresS, setAreaInteresS] = useState("");
  const [programaInteresS, setProgramasInteresS] = useState("");
  const [aviso, setAviso] = useState(AvisoInput);
  const [showForm, setShowForm] = useState(true);
  const [isBotonBloqueado, setIsBotonBloqueado] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const handlePhoneChange = (value, country) => {
    setPhoneNumber(value);
    setTelefono(value);
    document.getElementById("telefonoP").textContent = "";
  };
    const [TextoHorario, setTextoHorario] = useState("Este horario no es para participar en el evento, sino para brindar acompañamiento en el proceso de admisión.")

    function esCorreoElectronico(texto) {
      const expresionRegular = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      //const expresionRegular = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  
      return expresionRegular.test(texto);
    }


    const handleChangeAviso = (e) => {
    e.target.checked ? setAviso(1) : setAviso(0);
    document.getElementById("avisosP").textContent = "";
  };



  //console.log(areaInteresS);
  //console.log(programaInteresS);

  //console.log("phone="+phoneNumber);
  /*  const url = new URL(window.location.href);
  const cValue = url.searchParams.get("c");*/

  function restaFecha(anniosRest) {
    var today = new Date();

    let annios = 1000 * 60 * 60 * 24 * 365 * anniosRest;
    let resta = today.getTime() - annios;

    let fechaNueva = new Date(resta);
    var yearN = fechaNueva.getFullYear();

    return yearN;
  }

  const handleButtonClick = () => {
    setShowForm(true);
  };
  let navigate = useNavigate();

  //const claveCampusClear = ClCampus[0].replace(/FCOE_/g, '');
  //const claveCampusClear = ClCampus && ClCampus.length > 0 ? ClCampus.replace(/FCOE_/g, "") : "";
    const claveCampusClear =  Evento[0].event.id_campus;
  //console.log("claveCampusClear=" + claveCampusClear);
  // Imformación del evento
  //console.log(Evento);
  //console.log(Evento[0].event.urlname);

  const mandarTodo = (e) => {
    setIsBotonBloqueado(true);
    var fechacorregida = moment(fecha);
    if (
      nombre === "" ||
      apellidoPaterno === "" ||
      telefono === "" ||
      fecha === "" ||
      claveCampusClear === "" ||
      periodosS === "" ||
      areaInteresS === "" ||
      programaInteresS === "" ||
      sexoLegal === "" ||
      horario === "" ||
      email === "" ||
      aviso === 0 ) {
     
      setIsBotonBloqueado(false);
      //mostramos mensaje de que se debe de subir en los campos que no se han llenado
      if (nombre === "" || nombre.trim() === "") {
        if (isEnglish) {
          document.getElementById("nombreP").textContent = "Ingresa el nombre.";
        } else {
          document.getElementById("nombreP").textContent = "Campo Obligatorio";
        }
      }
      if (apellidoPaterno === "" || apellidoPaterno.trim() === "") {
        if (isEnglish) {
          document.getElementById("apellidoPaternoP").textContent =
            "Ingresa tu primer apellido.";
        } else {
          document.getElementById("apellidoPaternoP").textContent =
            "Campo Obligatorio";
        }
      }
      if (telefono === "" || telefono.trim() === "") {
        if (isEnglish) {
          document.getElementById("telefonoP").textContent =
            "Ingresa tu número de teléfono.";
        } else {
          document.getElementById("telefonoP").textContent =
            "Campo Obligatorio";
        }
      }
      if (fecha === "") {
        if (isEnglish) {
          document.getElementById("fechaP").textContent =
            "Ingresa tu fecha de nacimiento";
        } else {
          document.getElementById("fechaP").textContent = "Campo Obligatorio";
        }
      }

      if (sexoLegal === "" || sexoLegal.trim() === "") 
        document.getElementById("sexoP").textContent = "Debes seleccionar tu sexo para continuar";

      if (email === "" || email.trim() === "") 
        document.getElementById("correoP").textContent = "Ingresa un correo electrónico para continuar";

       if(!esCorreoElectronico(email))
         document.getElementById("correoP").textContent = "Ingresa un correo electrónico  válido";

      if (horario === "" || horario.trim() === "") 
        document.getElementById("horarioP").textContent = "Debes seleccionar un horario preferido para continuar";

      if (campusS === "") {
        if (isEnglish) {
          document.getElementById("campusP").textContent =
            "Selecciona un campus.";
        } else {
          document.getElementById("campusP").textContent = "Campo Obligatorio";
        }
      }
      if (periodosS === "") {
        if (isEnglish) {
          document.getElementById("periodoP").textContent =
            "Selecciona una fecha esperada de ingreso.";
        } else {
          document.getElementById("periodoP").textContent = "Campo Obligatorio";
        }
      }
      if(mustraSelects){
      if (areaInteresS === "") {
        if (isEnglish) {
          document.getElementById("areaP").textContent =
            "Debes seleccionar una entrada de interés para continuar.";
        } else {
          document.getElementById("areaP").textContent = "Campo Obligatorio";
        }
      }
      if (programaInteresS === "") {
        if (isEnglish) {
          document.getElementById("programaP").textContent =
            "Debes seleccionar una programa de interés para continuar";
        } else {
          document.getElementById("programaP").textContent =
            "Campo Obligatorio";
        }
      }
    }
      if (aviso === 0) {
        if (isEnglish) {
          document.getElementById("avisosP").textContent =
            "El campo es requerido";
        } else {
          document.getElementById("avisosP").textContent = "Campo Obligatorio";
        }
      }
    } else {
      //localStorage.setItem('paisID', JSON.parse(paisS).key)
      const cmpaInput = document.getElementById("cmpaForm");
      const cmpaValue = cmpaInput.value.replace(/CMPA-/g, "");

      const eventoInput = document.getElementById("eventoForm");
      const eventoValue = eventoInput.value.replace(/EVE-/g, "");

      const contextoForm = document.getElementById("contextoForm");
      const concetxtoValue = contextoForm.value;

      const nivelInput = document.getElementById("nivelForm");
      const NivelValue = nivelInput.value;
      console.log(NivelValue)

      const idLandingInput = document.getElementById("idLanding");
      const idLandingValue = idLandingInput.value;
      console.log(idLandingValue);

      const utm_termInput = document.getElementById("utm_term");
      const utm_termValue = utm_termInput.value;
      console.log(utm_termValue);
    
      const referInput = document.getElementById("refer");
      const referValue = referInput.value;

      const landingFormInput = document.getElementById("landingForm");
      const landingFormValue = landingFormInput.value;

      const nombreRegistroVal = landingFormValue; //"Eventos " + concetxtoValue; //Eventos Guadalajara

      const utm_crm_campaign_input = localStorage.getItem("utm_crm_campaign_Local");
      const utm_cmpa_input = localStorage.getItem("utm_cmpa_Local");
      const campusId=Evento[0].event.id_campus;
      
      let CampusKey='';
      if (campusId === "VC") {
        if (localStorage.getItem("campusStorageSed")) {
           CampusKey = localStorage.getItem("campusStorageSed");
        } else  CampusKey ="A";
      } else CampusKey=campusS;

      CampusKey=JSON.parse(CampusKey);

      var cmpaSend= cmpaValue
      if(cmpaSend==="" || cmpaSend === null)
      cmpaSend=InfoCampus[0].campana

      // console.error("test");
      const urlParams = new URLSearchParams(window.location.search)
      const utm_medium_send = urlParams.get('utm_medium')
      const utm_source_send = urlParams.get('utm_source')
      const utm_term_send = urlParams.get('utm_term')
      const utm_content_send = urlParams.get('utm_content')
      const utm_campaign_send = urlParams.get('utm_campaign')

      debugger
      const credentials = {
        name: nombre,
        lastName: apellidoPaterno,
        secondLastName: apellidoMaterno,
        celularPhone: telefono,
        email: email,
        birthDate: fechacorregida.format("DD/MM/YYYY"),
        escuelasprov: EscuelaProveedoraS, //JSON.parse(paisS).key,  //JSON.pase(paisS).nombre   <- Para enviar el nombre y no el ID
        sede: CampusKey.key,
        atentionSede: CampusKey.key,
        schoolKey : claveCampusClear,
        period: JSON.parse(periodosS).key,
        area: JSON.parse(areaInteresS).key,
        program: JSON.parse(programaInteresS).key,
        avisos: aviso,
        cmpa: cmpaSend,
        event: eventoValue,
        contexto: concetxtoValue,
        grade: "profesional",
        landingUrl: "https://calendario.tec.mx/evento/"+Evento[0].event.urlname,
        formName: Evento[0].event.id_evento+Evento[0].event.urlname,
        landing: nombreRegistroVal,
        utmTerm: utm_term_send,
        utmMedium: utm_medium_send,
        utmSource: utm_source_send,
        utmContent: utm_content_send,
        utmCampaign: utm_campaign_send,
        utmCrmCampaign: utm_crm_campaign_input,
        utmCmpa: utm_cmpa_input,
        refer: referValue,
        gender : JSON.parse(sexoLegal).nombre,
        preferredAtentionTime: JSON.parse(horario).nombre,
        //ENVIAR A hubspot
        sendhubspot: "true",
        sendsalesforce: "true",
        SaveSpotServer: SaveSpotGuarda
      };

     

      if(!eventoValue)
        delete credentials.utmTerm;

      
      //console.log(credentials);
      //console.log(JSON.stringify(credentials))

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        // mode: 'no-cors', // Establecer el modo no-cors
        body: JSON.stringify(credentials),
      };
      //console.log(options);

      fetch(apiUrlGestor + "enviaRegistro.php", options)
        .then((response) => response.json())
        .then(sleep(2000))
        .then((data) => {
          // Manipular los datos de la respuesta
          console.log(data);

          // alert("se envió con exito");
          localStorage.removeItem("utm_term_Local");
          localStorage.removeItem("utm_medium_Local");
          localStorage.removeItem("utm_source_Local");
          localStorage.removeItem("utm_content_Local");
          localStorage.removeItem("utm_campaign_Local");
          localStorage.removeItem("utm_crm_campaign_Local");
          localStorage.removeItem("expiracion");
          setIsBotonBloqueado(false);
          viweForm(null);
          navigate(
            "../"+urlRoot+"/"+eventRoot+"/evento/" + Evento[0].event.urlname + "/gracias?g=1#confirmacion"
          );
        })
        .catch((error) => {
          console.log(error);
          setIsBotonBloqueado(false);
        });
      //localStorage.setItem('correo', correo)
    }

    e.preventDefault();
    EventoRegistrado();
    //navigate("../evento/" + Evento[0].event.urlname + "/gracias#confirmacions");
  };

    // =================== SEXO LEGAL ======================
  const consultaSexoLegal = useCallback(() => {

      const options = {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      };

      fetch(apiODD+"api/v1/genders", options)
        .then((response) => response.json())
        .then((datos) => {
          //console.log("genders",datos);
          setGeneros(datos['gender'])
        });

  }, []);

      // =================== Horario preferido de atención ======================
  const consultaHorarioPreferido = useCallback(() => {

      const options = {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      };

      fetch(apiODD+"api/v1/atentionTime", options)
        .then((response) => response.json())
        .then((datos) => {
          setHorarios(datos['preferredAtentionTime'])
        });

  }, []);

  // =================== CAMPUS ======================
  const consultaCampus = useCallback(() => {

    var data = {
      "filters": {
        "grade": {
          "slug": "profesional"
        }
      }
    }

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data) // Convertir datos a JSON
      };

      fetch(apiODD+"api/v1/campuses/search-active-offering", options)
        .then((response) => response.json())
        .then((datos) => {
        //  console.log(datos['campuses']);
          setCampus(datos['campuses']);
        });
  }, []);

  // =================== PERIODOS ======================
    const consultaPeriodos = useCallback(
      (campusS) => {
    let campusx;
    try {
      campusx = campusS;
    } catch (error) {
      campusx = "";
    }

    campusx=JSON.parse(campusx);

    var data = {
      "include": { "offerings": true },
      "filters": {
        "campus": { "soadKey": campusx.key },
        "grade": { "soadKey": "05" }
      } }

      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data) // Convertir datos a JSON
      };

      fetch(apiODD+"api/v1/campuses/search-active-offering", options)
        .then((response) => response.json())
        .then((datos) => {
          //console.log(datos['campuses'][0]['offerings']);
          setPeriodos(datos['campuses'][0]['offerings']);
        });
  }, []);

  // =================== AREA ======================
  const consultaAreaInteres = useCallback(
    (claveCampusClear, periodoS, NivelEvento) => {

      let campus, periodo;
      try {
        campus = claveCampusClear;
        periodo = JSON.parse(periodoS).key;
      } catch (error) {
        campus = "";
        periodo = "";
      }

      campus=JSON.parse(campus);

      var data = {
        "filters": {
          "campus": {
            "soadKey": campus.key
          },
          "period": {
            "soadKey": periodo
          },
          "grade": {
            "soadKey": "05"
          }
        }
      }
  
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data) // Convertir datos a JSON
        };
  
        fetch(apiODD+"api/v1/areas/search-active-offering", options)
          .then((response) => response.json())
          .then((datos) => {
           console.log(datos['areas']);
           setAreaInteres(datos['areas']);
          });
        },
    []
  );

  // =================== PROGRAMA ======================
  const consultaPrograma = useCallback(
    (claveCampusClear, periodoS, areaS, NivelEvento) => {

      let campus, periodo, area;
      try {
        campus = claveCampusClear;
        periodo = JSON.parse(periodoS).key;
        area = JSON.parse(areaS).key;
      } catch (error) {
        campus = "";
        periodo = "";
        area = "";
      }

      var data = {
        "filters": {
            "campus": {
                "soadKey": campus.key
            },
            "period": {
                "soadKey": periodo
            },
            "grade": {
                "soadKey": "05"
            },
            "area": {
                "soadKey": area
            }
        }
    }

    if(Evento[0].event.nivel==="03")
      delete data.filters.area
  
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data) // Convertir datos a JSON
        };
  
        fetch(apiODD+"api/v1/programs/search-active-offering", options)
          .then((response) => response.json())
          .then((datos) => {
           // console.log(datos['programs']);
           setProgramasInteres(datos['programs']);
          });
        },
    [Evento]
  );

  //============================ DATA ==================================================

  const handleChange = (e) => {
    if (e.target.id === "nombre") {
      setNombre(e.target.value);
    } else if (e.target.id === "apellidoPaterno") {
      setApellidoPaterno(e.target.value);
    } else if (e.target.id === "apellidoMaterno") {
      setApellidoMaterno(e.target.value);
    } else if (e.target.id === "fecha") {
      setFecha(e.target.value);
    } else if (e.target.id === "EscuelaProveedora") {
      setEscuelaProveedoraS(e.target.value);
    } else if (e.target.id === "campus") {
      setmustraSelects(true)
      setCampusS(e.target.value);
      setPeriodos(null);
      setAreaInteres(null);
      setProgramasInteres(null);
      setmustraArea(false)
      setmusPrograma(false)

      consultaPeriodos(e.target.value)
    } else if (e.target.id === "periodo") {
      
      const myJSON = e.target.value;
      const myObj = JSON.parse(myJSON);
//      console.log(myObj.key);

      if (myObj.key === "otro") {
        setPeriodosS('{"periodo":"otro","key":"otro"}');
        //document.getElementById("area").style.display = "none";
        setmustraArea(false)
        //document.getElementById("programa").style.display = "none";
        setmusPrograma(false)
        setAreaInteresS('{"nombre":"otro","key":"otro"}');
        setProgramasInteresS('{"nombre":"otro","key":"otro"}');
      } else {
        

        setPeriodosS(e.target.value);
        if (NivelEvento === "03") {
          var area = '{"nombre":"Prepa","key":"046"}';
          setAreaInteresS(area);
          //document.getElementById("area").style.display = "none";
          setmustraArea(false)
          //document.getElementById("programa").style.display = "block";
          setmusPrograma(true)
          //consultaPrograma(claveCampusClear, e.target.value, area, NivelEvento);
          setmusPrograma(true)
        } else {
          //document.getElementById("area").style.display = "block";
          setmustraArea(true)
          //document.getElementById("programa").style.display = "block";
          setmusPrograma(true)

          setAreaInteres(null);
          setProgramasInteres(null);
          setAreaInteresS("");
          setProgramasInteresS("");
          consultaAreaInteres(campusS, e.target.value);
        } //END ELSE
      }
    } else if (e.target.id === "area") {
      setAreaInteresS(e.target.value);
      setProgramasInteres(null);
      setProgramasInteresS("");
      consultaPrograma(campusS, periodosS, e.target.value);
    } else if (e.target.id === "programa") {
      setProgramasInteresS(e.target.value);
    } else if (e.target.id === "avisos") {
      e.target.checked ? setAviso(1) : setAviso(0);
    } else if (e.target.id === "sexo") {setsSxoLegal(e.target.value) }
      else if (e.target.id === "horario") { setHorario(e.target.value) }
      else if (e.target.id === "correo") { setEmail(e.target.value) }
      else {
      console.log("ERROR id no encontrado");
    }

    if ( e.target.id === "avisos" && !e.target.checked ) {

        document.getElementById(e.target.id + "P").textContent =
          "Este campo es requerido";
      
    } else {
      // console.log(e.target.id);
      document.getElementById(e.target.id + "P").textContent = "";
    }
  };

  useEffect(() => {
    
    // se ejecuta cada vez que isEnglish cambie para volver a hacer la consulta a la API
    // debemos llamar a las APIs otra vez para conseguir su versión del nuevo idioma seleccionado

        consultaSexoLegal()
    consultaHorarioPreferido()

    if(!campus)
    consultaCampus(); // esta siempre se debe llamar
    //consultaPeriodos(claveCampusClear);

        const tipoEvento = Evento[0].event.tipo_evento;
    console.log("tipoEvento", tipoEvento);

    switch (tipoEvento) {
      case '902106':
      case '902105':
        setTextoHorario("Brindaremos acompañamiento en el proceso de admisión según el horario indicado.")
        break;
    
      default:
        break;
    }

  }, [
    isEnglish,
    claveCampusClear,
    consultaCampus,
    consultaPeriodos,
    consultaAreaInteres,
    consultaPrograma,
    periodosS,
    areaInteresS,
    NivelEvento,
    campus,
    consultaSexoLegal,
    consultaHorarioPreferido,
    Evento
  ]);

  useEffect(() => {
    // este solo se debe ejecutar una vez
    if (localStorage.getItem("ingles") == null) {
      localStorage.setItem("ingles", 0); // si no hay una opción seleccionada lo pongo en español
    }
    setisEnglish(localStorage.getItem("ingles"));
  }, []);

  var campusNameInput;

  if (Evento[0].event.campuses.length > 1 && localStorage.getItem("campusStorageNameSed"))
    campusNameInput = localStorage.getItem("campusStorageNameSed");
  else
  {

  if(InfoCampus[0].name)
  campusNameInput = InfoCampus[0].name;
else{

  if (localStorage.getItem("campusStorageNameSed")) 
    campusNameInput = localStorage.getItem("campusStorageNameSed");
  
}
}

    switch (campusNameInput) {
      case "Ciudad de México":
        campusNameInput = "cdmx";
        break;

      case "Ciudad Juárez":
        campusNameInput = "ciudad-juarez";
        break;

      case "Ciudad Obregón":
        campusNameInput = "ciudad-obregon";
        break;

      case "Estado de México":
        campusNameInput = "estado-de-mexico";
        break;

      case "León":
        campusNameInput = "leon";
        break;

      case "Querétaro":
        campusNameInput = "queretaro";
        break;

      case "San Luis Potosí":
        campusNameInput = "san-luis-potosi";
        break;

      case "Santa Fe":
        campusNameInput = "santa-fe";
        break;

      case "Eugenio Garza Lagüera":
        campusNameInput = "prepatec-monterrey";
        break;

      case "Eugenio Garza Sada":
        campusNameInput = "prepatec-monterrey";
        break;

      case "prepatec-guadalajara":
        campusNameInput = "Santa Anita";
        break;

      case "Santa Catarina":
        campusNameInput = "prepatec-monterrey";
        break;

      case "Sonora Norte":
        campusNameInput = "prepatec-sonora-norte";
        break;

      case "Valle Alto":
        campusNameInput = "prepatec-monterrey";
        break;

      case "Cumbres":
        campusNameInput = "prepatec-monterrey";
        break;

      case "Esmeralda":
        campusNameInput = "prepatec-cdmx";
        break;

      default:
        //console.log("");
        break;
    } //switch

    try {
      campusNameInput = campusNameInput.toLowerCase();
} catch (error) {
  console.error("campusNameInput error");
}

  

  //console.log("campusName=" + campusNameInput);

  const utm_source_input = localStorage.getItem("utm_source_Local");
  const utm_medium_input = localStorage.getItem("utm_medium_Local");
  const utm_term_input = localStorage.getItem("attr_tec_term");

  return (
    <>

<Grid  spacing={2}>
      <div id="formluario" className="formsReg">
        <div className="textoarribaRegistro"></div>
        <div className="row m-0 p-0" style={{ justifyContent: "center" }}>
          <div className="contform col-md-8 col-xs-12">
            {showForm && (
              <form onSubmit={mandarTodo}>
                <div id="hiddens">
                  {Evento.map((eventos) => (
                    <>
                      <input
                        type="hidden"
                        id="nombreRegistro"
                        name="nombreRegistro"
                        value={`Evento ${eventos.event.id_evento}`}
                      />

                      <input
                        type="hidden"
                        name="landing"
                        id="landingForm"
                        value={`Evento-${eventos.event.id_evento}`}
                      />
                      <input
                        type="hidden"
                        name="origenDestino"
                        id="origenDestinoForm"
                        value="Profesional de Preparatoria No Tec"
                      />
                      <input
                        type="hidden"
                        name="retURL"
                        value="https://admision.tec.mx/uat/profeareayprogramatec21/prod_test/savespot_profe_pruebas_todos?gracias=gracias#contact"
                      />
                      <input
                        type="hidden"
                        name="refer"
                        id="refer"
                        value={`https://calendario.tec.mx/evento/${eventos.event.urlname}`}
                      />
                      <input
                        type="hidden"
                        name="cmpa"
                        id="cmpaForm"
                        value={ eventos.event.cmpa}
                      />
                      <input
                        type="hidden"
                        name="evento"
                        id="eventoForm"
                        value={eventos.event.fonteva}
                      />
                      <input
                        type="hidden"
                        name="utm_term"
                        id="utm_term"
                        value={utm_term_input}
                      />
                      <input
                        type="hidden"
                        name="contexto"
                        id="contextoForm"
                        value={`${campusNameInput}`}
                      />
                      <input
                        type="hidden"
                        name="contextoInit"
                        id="contextoFormInit"
                        value={`${campusNameInput}`}
                      />
                      <input
                        type="hidden"
                        name="nivel"
                        id="nivelForm"
                        value={eventos.event.nivel}
                      />
                      <input type="hidden" name="flag" id="flag" value="1" />
                      <input
                        type="hidden"
                        name="idLanding"
                        id="idLanding"
                        value="201"
                      />
                      <input
                        type="hidden"
                        name="utm_source"
                        id="utm_source"
                        value={utm_source_input}
                      />
                      <input
                        type="hidden"
                        name="utm_medium"
                        id="utm_medium"
                        value={utm_medium_input}
                      />
                    </>
                  ))}
                </div>

                <div className="preg">
                  <input
                    type="text"
                    placeholder="Nombre(s) del estudiante interesado"
                    className="form-control effect-10"
                    id="nombre"
                    onChange={handleChange}
                  />
                  <span class="focus-bg"></span>
                  <p className="errorForm" id="nombreP"></p>
                </div>
                <div className="preg">
                  <input
                    type="text"
                    placeholder="Primer apellido"
                    className="form-control"
                    id="apellidoPaterno"
                    onChange={handleChange}
                  />
                  <p className="errorForm" id="apellidoPaternoP"></p>
                </div>
                <div className="preg">
                  <input
                    type="text"
                    placeholder="Segundo apellido (opcional)"
                    className="form-control"
                    id="apellidoMaterno"
                    onChange={handleChange}
                  />
                  <p className="errorForm" id="apellidoMaternoP"></p>
                </div>

                <div className="preg">
                <input
                type="text"
                placeholder="Correo electrónico del estudiante"
                className="form-control effect-10"
                id="correo"
                onChange={handleChange}
              />
              <p id="correoMsg">
              Si ya te has registrado previamente, por favor usa el mismo correo.<br></br> Si eres padre, madre o tutor(a), ingresa el correo del estudiante interesado.
              </p>
              <p className="errorForm" id="correoP"></p>
                {/* LABEL: */}

                </div>
                <div className="preg">
                  <label htmlFor="telefono">Celular del estudiante interesado</label>
                  <PhoneInput
                    inputProps={{
                      name: "telefono",
                      required: true,
                    }}
                    inputExtraProps={{
                      className: "form-control", // Agrega tu clase personalizada aquí
                    }}
                    inputStyle={{ width: "100%" }}
                    country={"mx"}
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                    placeholder="Celular del estudiante interesado"
                  />
                  <p className="errorForm" id="telefonoP"></p>
                </div>

                <div className="FechaPadre">
                  <div className="Fecha">
                    <label htmlFor="fecha">
                      Fecha de nacimiento (dd/mm/aaaa):
                    </label>
                  </div>
                  {/* 24/09/2002 <- FORMATO CORRECTO  data-date-format='DD MMM YYYY'  */}
                  <div className="funfecha">
                    <input
                      type="date"
                      id="fecha"
                      name="fecha"
                      className="form-control"
                      data-date=""
                      data-date-format="DD MMMM YYYY"
                      onChange={handleChange}
                      min={restaFecha(40) + "-01-01"}
                      max={restaFecha(11) + "-12-31"}
                    />
                    <p className="errorForm" id="fechaP"></p>
                  </div>
                </div>

                {/*====================================================SELECTS=========================================================== */}

                  <div className="form-group" id="select">
                  <select
                  style={{appearance:"auto"}} 
                    id="sexo"
                    name="sexo"
                    data-value=""
                    className="form-control"
                    aria-required="true"
                     onChange={handleChange}
                  >
                    <option key="" selected disabled value="">
                      Sexo
                    </option>
                   {generos &&
                      generos.map(({ id, value, name }) => (
                        <option
                          key={id}
                          value={JSON.stringify({
                            nombre: value,
                            key: id,
                          })}
                        >
                          {name}
                        </option>
                      ))}
                  </select>
                  <p className="errorForm" id="sexoP"></p>
                </div>

                <div className="form-group" id="select">
                  <select
                    id="campus"
                    name="campus"
                    data-value=""
                    className="form-control"
                    aria-required="true"
                    onChange={handleChange}
                  >
                    <option key="" value="" selected disabled>
                      Selecciona un campus de interés
                    </option>
                    {campus &&
                      campus.map(({ id, name, slug, soadKey }) => (
                        <option
                          id={soadKey}
                          key={soadKey}
                          value={JSON.stringify({
                            nombre: name,
                            key: soadKey,
                          })}
                        >
                          {name}
                        </option>
                      ))}
                  </select>
                  <p className="errorForm" id="campusP"></p>
                </div>
                {mustraSelects && (
                  <>
                <div className="form-group" id="select">
                  <select
                    id="periodo"
                    name="periodo"
                    data-value=""
                    className="form-control"
                    aria-required="true"
                    onChange={handleChange}
                  >
                    <option key="" selected disabled value="">
                      Fecha esperada de ingreso
                    </option>
                    {periodos && periodos.map(({ period }) => (
                      period.soadKey !== 'otro' && (
                      <option key={period.soadKey} value={JSON.stringify({ periodo: period.name, key: period.soadKey, })} >
                        {period.name}
                        </option> )
                        ))}
                  </select>
                  <p className="errorForm" id="periodoP"></p>
                </div>


 
                {mustraArea && (
                  <>
                <div className="form-group" id="select">
                  <select
                    id="area"
                    name="area"
                    data-value=""
                    className="form-control"
                    aria-required="true"
                    onChange={handleChange}
                  >
                    <option key="" value="">
                      Selecciona un entrada de interés
                    </option>
                    {areaInteres &&
                      areaInteres.map(({ id, name, soadKey }) => (
                        <option
                          key={soadKey}
                          value={JSON.stringify({
                            nombre: name,
                            key: soadKey,
                          })}
                        >
                          {name}
                        </option>
                      ))}
                  </select>
                  <p className="errorForm" id="areaP"></p>
                </div>
                </>
                )}

                  {mustraPrograma && (
                  <>
                <div className="form-group" id="select">
                  <select
                    id="programa"
                    name="programa"
                    data-value=""
                    className="form-control"
                    aria-required="true"
                    onChange={handleChange}
                  >
                    <option value="">Selecciona un programa de interés</option>
                    {programaInteres &&
                      programaInteres.map(({ id, name, soadKey }) => (
                        <option
                          key={soadKey}
                          value={JSON.stringify({
                            nombre: name,
                            key: soadKey,
                          })}
                        >
                          {name}
                        </option>
                      ))}
                  </select>
                  <p className="errorForm" id="programaP"></p>
                </div>
                </>
                )}

                </>
                )}
                {/*======================================================================================================================================= */}

                          <div className="form-group" id="select">
                  <select
                  style={{appearance:"auto"}}
                    id="horario"
                    name="horario"
                    data-value=""
                    className="form-control"
                    aria-required="true"
                     onChange={handleChange}
                  >
                    <option key="" selected disabled value="">
                     Horario para ser contactado por nuestros asesores
                    </option>
                   {horarios &&
                      horarios.map(({ id, value, name }) => (
                        <option
                          key={id}
                          value={JSON.stringify({
                            nombre: value,
                            key: id,
                          })}
                        >
                          {name}
                        </option>
                      ))}
                  </select>
                                                          
                      <label htmlFor="horario">
                      {TextoHorario}
                    </label>
                  <p className="errorForm" id="horarioP"></p>
                </div>
               <div className="form-group" id="select">
                              <label
                                className="checkbox-inline"
                                htmlFor="avisos"
                              >
                                <input
                                  type="checkbox"
                                  id="avisos"
                                  name="avisos"
                                  onChange={handleChangeAviso}
                                />{" "}
                                He leído y acepto los términos y condiciones del{" "}
                                <a
                                  href="https://tec.mx/es/aviso-de-privacidad-prospectos"
                                  target="blank_"
                                  rel="noopener"
                                >
                                  <b>AVISO DE PRIVACIDAD</b>
                                </a>{" "}
                                del Tecnológico de Monterrey.
                              </label>
                              <p className="errorForm" id="avisosP"></p>
                            </div>
                <br />
                <br />
                <Grid container spacing={8}>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={9}>
                    <input
                      id="btnSend"
                      className={`btnreg sendBottom ${
                        isBotonBloqueado ? "bloqueado" : ""
                      }`}
                      type="submit"
                      value={isBotonBloqueado ? "Enviando..." : "REGÍSTRATE"}
                      disabled={isBotonBloqueado}
                    />
                  </Grid>
                  <Grid item xs={1}></Grid>
                  
                </Grid>
                
              </form>
            )}
          </div>
        </div>

        {!showForm && (
          <button
            className="titreg"
            onClick={handleButtonClick}
            style={{ marginBottom: "2%" }}
          >
            Regístrate Aquí
          </button>
        )}
      </div>
      </Grid>
    </>
  );
}

export { Form };
